import { render } from "./Leaderboards.vue?vue&type=template&id=a9ddcc36&scoped=true"
import script from "./Leaderboards.vue?vue&type=script&lang=ts"
export * from "./Leaderboards.vue?vue&type=script&lang=ts"

import "./Leaderboards.vue?vue&type=style&index=0&id=a9ddcc36&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a9ddcc36"

export default script